import { Link } from "wouter";
import SEO from "@/components/SEO";
import { getPublicPages } from "@/lib/siteRoutes";

export default function SiteMap() {
  const pages = getPublicPages();
  return <div>
    <SEO title="Website Sitemap | OC Recruitment" description="Browse OC Recruitment's retained-search services, eight packaging sectors, hiring insights, and contact information for US packaging sales recruitment." canonical="/site-map" />
    <section className="bg-midnight pt-32 pb-16"><div className="container">
      <p className="text-steel text-sm font-semibold uppercase tracking-[0.2em] mb-4">Explore OC Recruitment</p>
      <h1 className="text-4xl sm:text-5xl text-white mb-6">Website Sitemap</h1>
      <p className="text-white/70 max-w-2xl leading-relaxed">Find our retained-search process, the eight packaging sectors we cover, and practical guidance on hiring and careers in US packaging sales.</p>
    </div></section>
    <section className="py-16 lg:py-24 bg-white"><div className="container grid md:grid-cols-3 gap-12">
      {(["Company", "Packaging sectors", "Insights"] as const).map(group => <div key={group}>
        <h2 className="text-2xl text-midnight mb-6">{group}</h2>
        <ul className="space-y-4">{pages.filter(page => page.group === group && page.path !== "/site-map").map(page => <li key={page.path}>
          <Link href={page.path} className="text-steel text-sm leading-relaxed hover:underline">{page.label}</Link>
        </li>)}</ul>
      </div>)}
    </div></section>
  </div>;
}
